/* eslint-disable */
import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ModalController, NavParams, Platform, ToastController } from '@ionic/angular';
import { Subscription } from 'rxjs';
import { CONSTANTS } from 'src/app/services/config.service';
import { LoggerService } from 'src/app/services/logger.service';
import { MapsTransitService } from 'src/app/services/maps-transit.service';
import { PointsHelperService } from 'src/app/services/points-helper.service';
import { MSRemoteLoggerCategory } from 'src/app/adapters/remote-logger/utils/remote-logger.utils';

@Component({
  selector: 'app-transit-map',
  templateUrl: './transit-map.page.html',
  styleUrls: ['./transit-map.page.scss']
})
export class TransitMapPage implements OnInit {
  @ViewChild('map') mapElement: ElementRef;
  data: any = {};
  pointsStartStop: any = [];
  points: any = [];
  mapLoaded: boolean;
  mapTab = 'overview';
  START_STOP_ZOOM = 7;
  chosenPoint: any = { lat: 0, lng: 0, text: '', value: 0 };
  selectedPoint: any = { lat: 0, lng: 0, text: '', value: 0 };
  isDevice = !!CONSTANTS.IS_DEVICE;
  showBingExitButton = true;
  disableSelectButton = false;
  subToBingMaps: Subscription;
  subToBingMapsNCE: Subscription;
  subToZoomInCloser: Subscription;
  subToNativeMaps: Subscription;
  subToHardwareBackButton: Subscription;
  items: any;
  answer: any;
  prompt = '';

  constructor(
    private navParams: NavParams,
    public modalCtrl: ModalController,
    private logger: LoggerService,
    private bingMaps: MapsTransitService,
    // private nativeMaps: MapsNativeService,
    private toastController: ToastController,
    private platform: Platform,
    private pointsHelper: PointsHelperService
  ) {
    this.subToHardwareBackButton = this.platform.backButton.subscribeWithPriority(9999, () => {
      this.logger.log('Transit Backbutton handler called!', MSRemoteLoggerCategory.SURVEY_TRANSIT_MAP_PAGE);
      this.dismissNoneChosen();
    });
  }

  // setBounds(center, radiusMeters) {
  //     let latDelta = this.gis.getLatDegrees(radiusMeters);
  //     let north = { lat: center.lat + latDelta, lng: center.lng };
  //     let south = { lat: center.lat - latDelta, lng: center.lng };
  //     this.maps.setMapBounds([north, center, south]);
  // }

  /**********************************************************************************************************************************************************************
   * SET MAP VIEW
   ***********************************************************************************************************************************************************************/

  showOverview() {
    // this.maps.setMapType('MAP_TYPE_NORMAL');
    // this.maps.showOverview();
    this.bingMaps.setMapTypeId('road');
    this.bingMaps.showTransitOverview();
  }

  /**********************************************************************************************************************************************************************
   * NAVIGATE
   ***********************************************************************************************************************************************************************/

  dismissNoneChosen() {
    this.chosenPoint = { lat: 0, lng: 0, text: '', value: 0 };
    this.dismiss();
  }

  dismiss() {
    // this.maps.removeMap()
    //     .then(() => {
    //         // this.logger.log(`Transit chosenPoint is ${JSON.stringify(this.chosenPoint)}`)
    //         this.modalCtrl.dismiss(this.chosenPoint);
    //     })
    this.modalCtrl.dismiss(this.chosenPoint);
  }

  init() {
    this.logger.log('ionViewDidLoad MapTransitPage', MSRemoteLoggerCategory.SURVEY_TRANSIT_MAP_PAGE);
    this.data = this.navParams.data.data;
    this.prompt = this.navParams.data.prompt;
    this.points = this.navParams.data.points;
    this.answer = this.navParams.data.answer;

    // this.maps.initTransit(this.mapElement.nativeElement, this.points[0], this.points)
    //     .then(() => {
    //         return this.maps.addMarkersAndPathTransit(this.points);
    //     })
    //     .then(() => {
    //         this.showOverview();
    //         this.mapLoaded = true;
    //         // this.mapTab = 'overview';
    //     })
    //     .catch(err => {
    //         this.logger.log('****MAP ERROR****', err);
    //     })

    // this.pointsHelper.getPoints(this.data.earlier, this.data.survey, this.data.isLongDistance, false)
    //     .then(res => {
    //         //[{"lat":38.88561,"lng":-77.06069,"time":1644643802},{"lat":38.88153,"lng":-77.01172,"time":1644644042}]
    //         this.pointsStartStop.push({ "lat": res.locations[0].lat, "lng": res.locations[0].lng, "text": "Start", "value": -100 })
    //         this.pointsStartStop.push({ "lat": res.locations[res.locations.length - 1].lat, "lng": res.locations[res.locations.length - 1].lng, "text": "Stop", "value": -200 })
    //         const mapCenter = this.getMapCenter(this.points, this.pointsStartStop);
    //         // this.logger.log(`Transittt pointsStartStop is  ${JSON.stringify(this.pointsStartStop)}`);
    //         // this.logger.log(`Transittt points is  ${JSON.stringify(this.points)}`);
    //         // this.logger.log(`Transittt ${JSON.stringify(mapCenter)}`);
    //         return this.bingMaps.init(this.mapElement.nativeElement, this.pointsStartStop, this.points, mapCenter)
    //     })
    //     // .then(() => {
    //     //     return this.bingMaps.addMarkersAndPath(this.pointsStartStop, this.data.survey);
    //     // })
    //     .then(() => {
    //         return this.bingMaps.addMarkersAndPathTransit(this.points);
    //     })
    //     .then(() => {
    //         this.showOverview();
    //         this.mapLoaded = true;
    //         // this.mapTab = 'overview';
    //     })
    //     .catch(err => {
    //         this.logger.log('****MAP ERROR****', err);
    //     })

    const mapCenter = this.getMapCenter(this.points, this.pointsStartStop);
    this.bingMaps
      .init(this.mapElement.nativeElement, this.pointsStartStop, this.points, mapCenter)
      .then(() => this.bingMaps.addMarkersAndPathTransit(this.points))
      .then(() => {
        this.showOverview();
        this.mapLoaded = true;
        // this.mapTab = 'overview';
      })
      .catch((err) => {
        this.logger.log('****MAP ERROR****', MSRemoteLoggerCategory.SURVEY_TRANSIT_MAP_PAGE, err);
      });
  }

  ionViewDidEnter() {
    this.logger.log(`Transit ionViewDidEnter`, MSRemoteLoggerCategory.SURVEY_TRANSIT_MAP_PAGE);
    this.init();
  }

  ionViewWillLeave() {
    this.logger.log(`Transit ionViewWillLeave`, MSRemoteLoggerCategory.SURVEY_TRANSIT_MAP_PAGE);
    this.dismiss();
  }

  ionViewDidLeave() {
    this.logger.log(`Transit ionViewDidLeave`, MSRemoteLoggerCategory.SURVEY_TRANSIT_MAP_PAGE);
  }

  ngOnInit() {
    this.logger.log(`Transit ngOnInit begins`, MSRemoteLoggerCategory.SURVEY_TRANSIT_MAP_PAGE);

    this.subToZoomInCloser = this.bingMaps.zoomInCloserSubject.subscribe(async () => {
      this.showBingExitButton = false;
      const toast = await this.toastController.create({
        header: 'Please tap on a stop or zoom in closer to make a selection.',
        position: 'bottom',
        color: 'light',
        duration: 4000
      });
      toast.present();
    });

    this.subToBingMapsNCE = this.bingMaps.chosenTransitPointNCESubject.subscribe(async () => {
      this.showBingExitButton = false;
      const toast = await this.toastController.create({
        header: 'We zoomed in closer.',
        message: 'Please select again.',
        position: 'bottom',
        color: 'light',
        duration: 2000
      });
      toast.present();
    });

    this.subToBingMaps = this.bingMaps.chosenTransitPointSubject.subscribe(async (point) => {
      this.chosenPoint = point;
      this.dismiss();
      this.logger.log(`Transit bing subscribed ${JSON.stringify(this.chosenPoint)}`, MSRemoteLoggerCategory.SURVEY_TRANSIT_MAP_PAGE);
    });
  }

  ngOnDestroy() {
    this.logger.log(`Transit ngOnDestroy begins`, MSRemoteLoggerCategory.SURVEY_TRANSIT_MAP_PAGE);
    this.subToBingMaps.unsubscribe();
    this.subToBingMapsNCE.unsubscribe();
    this.subToZoomInCloser.unsubscribe();
    // this.subToNativeMaps.unsubscribe();
    this.subToHardwareBackButton.unsubscribe();
    // this.maps.removeMap(true);
  }

  /**********************************************************************************************************************************************************************
   * HELPER FUNCTIONS
   ***********************************************************************************************************************************************************************/

  // get the center of the map containing all the points
  getMapCenter(points: any[], pointsStartStop: any[]) {
    let maxLat = -9999.0;
    let minLat = 9999.0;
    let avgLat = 0;

    let maxLng = -9999.0;
    let minLng = 9999.0;
    let avgLng = 0;

    for (const p of points) {
      //this.logger.log(`${p.lat} ${p.lng}`);

      if (p.lat > maxLat) {
        maxLat = p.lat;
      }
      if (p.lat < minLat) {
        minLat = p.lat;
      }
      if (p.lng > maxLng) {
        maxLng = p.lng;
      }
      if (p.lng < minLng) {
        minLng = p.lng;
      }
    }
    // for (const p of pointsStartStop) {
    //     this.logger.log(`${p.lat} ${p.lng}`);

    //     if (p.lat > maxLat) {
    //         maxLat = p.lat;
    //     }
    //     if (p.lat < minLat) {
    //         minLat = p.lat;
    //     }
    //     if (p.lng > maxLng) {
    //         maxLng = p.lng;
    //     }
    //     if (p.lng < minLng) {
    //         minLng = p.lng;
    //     }
    // }

    avgLat = (maxLat + minLat) / 2;
    avgLng = (maxLng + minLng) / 2;

    return { lat: avgLat, lng: avgLng };
  }
}
